module.exports = __webpack_public_path__ + "static/NotoSans-Italic.subset-3ad950a77796bf5727563a54e22bcb93.otf";